export default {
  'PerformerTagSection.tagTitle': { en: 'Popular Tags', fr: 'Tags populaires' },
};
